function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  "use strict";

  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode(".cdx-warning{position:relative}@media all and (min-width: 736px){.cdx-warning{padding-left:36px}}.cdx-warning [contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.cdx-warning [contentEditable=true][data-placeholder]:empty:before{opacity:1}.cdx-warning [contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.cdx-warning:before{content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='5' y='5' width='14' height='14' rx='4' stroke='black' stroke-width='2'/%3E%3Cline x1='12' y1='9' x2='12' y2='12' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M12 15.02V15.01' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");width:24px;height:24px;background-size:24px 24px;position:absolute;margin-top:8px;left:0}@media all and (max-width: 735px){.cdx-warning:before{display:none}}.cdx-warning__message{min-height:85px}.cdx-warning__title{margin-bottom:6px}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();

var n = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>';

var r = /*#__PURE__*/function () {
  /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {WarningData} data — previously saved data
   * @param {WarningConfig} config — user config for Tool
   * @param {object} api - Editor.js API
   * @param {boolean} readOnly - read-only mode flag
   */
  function r(_ref) {
    var e = _ref.data,
        t = _ref.config,
        s = _ref.api,
        i = _ref.readOnly;

    _classCallCheck(this, r);

    this.api = s, this.readOnly = i, this.titlePlaceholder = t.titlePlaceholder || r.DEFAULT_TITLE_PLACEHOLDER, this.messagePlaceholder = t.messagePlaceholder || r.DEFAULT_MESSAGE_PLACEHOLDER, this.data = {
      title: e.title || "",
      message: e.message || ""
    };
  }
  /**
   * Create Warning Tool container with inputs
   *
   * @returns {Element}
   */


  _createClass(r, [{
    key: "CSS",
    get:
    /**
     * Warning Tool`s styles
     *
     * @returns {object}
     */
    function get() {
      return {
        baseClass: this.api.styles.block,
        wrapper: "cdx-warning",
        title: "cdx-warning__title",
        input: this.api.styles.input,
        message: "cdx-warning__message"
      };
    }
  }, {
    key: "render",
    value: function render() {
      var e = this._make("div", [this.CSS.baseClass, this.CSS.wrapper]),
          t = this._make("div", [this.CSS.input, this.CSS.title], {
        contentEditable: !this.readOnly,
        innerHTML: this.data.title
      }),
          s = this._make("div", [this.CSS.input, this.CSS.message], {
        contentEditable: !this.readOnly,
        innerHTML: this.data.message
      });

      return t.dataset.placeholder = this.titlePlaceholder, s.dataset.placeholder = this.messagePlaceholder, e.appendChild(t), e.appendChild(s), e;
    }
    /**
     * Extract Warning data from Warning Tool element
     *
     * @param {HTMLDivElement} warningElement - element to save
     * @returns {WarningData}
     */

  }, {
    key: "save",
    value: function save(e) {
      var t = e.querySelector(".".concat(this.CSS.title)),
          s = e.querySelector(".".concat(this.CSS.message));
      return Object.assign(this.data, {
        title: t.innerHTML,
        message: s.innerHTML
      });
    }
    /**
     * Helper for making Elements with attributes
     *
     * @param  {string} tagName           - new Element tag name
     * @param  {Array|string} classNames  - list or name of CSS classname(s)
     * @param  {object} attributes        - any attributes
     * @returns {Element}
     */

  }, {
    key: "_make",
    value: function _make(e) {
      var _i$classList;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = document.createElement(e);
      Array.isArray(t) ? (_i$classList = i.classList).add.apply(_i$classList, _toConsumableArray(t)) : t && i.classList.add(t);

      for (var a in s) {
        i[a] = s[a];
      }

      return i;
    }
    /**
     * Sanitizer config for Warning Tool saved data
     *
     * @returns {object}
     */

  }], [{
    key: "isReadOnlySupported",
    get:
    /**
     * Notify core that read-only mode is supported
     */
    function get() {
      return !0;
    }
    /**
     * Get Toolbox settings
     *
     * @public
     * @returns {string}
     */

  }, {
    key: "toolbox",
    get: function get() {
      return {
        icon: n,
        title: "Warning"
      };
    }
    /**
     * Allow to press Enter inside the Warning
     *
     * @public
     * @returns {boolean}
     */

  }, {
    key: "enableLineBreaks",
    get: function get() {
      return !0;
    }
    /**
     * Default placeholder for warning title
     *
     * @public
     * @returns {string}
     */

  }, {
    key: "DEFAULT_TITLE_PLACEHOLDER",
    get: function get() {
      return "Title";
    }
    /**
     * Default placeholder for warning message
     *
     * @public
     * @returns {string}
     */

  }, {
    key: "DEFAULT_MESSAGE_PLACEHOLDER",
    get: function get() {
      return "Message";
    }
  }, {
    key: "sanitize",
    get: function get() {
      return {
        title: {},
        message: {}
      };
    }
  }]);

  return r;
}();

export { r as default };